import { useState, useEffect } from "react";
import { Company } from "../../../api";
import { useAuth } from "../../../hooks";
import { useCompany } from "../../../contexts";

const companyCtrl = new Company();

// Nombre de la empresa activa — usado en los encabezados de Inicio, Explorar
// y Registros. Centralizado acá porque las tres pantallas lo necesitan.
export function useCompanyName() {
  const { accessToken } = useAuth();
  const { company } = useCompany();
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    if (!company || company === "0") { setCompanyName(""); return; }
    companyCtrl.getCompany(accessToken, company)
      .then((res) => setCompanyName(res?.name || ""))
      .catch(() => setCompanyName(""));
  }, [accessToken, company]);

  return companyName;
}
